import { FC, useCallback } from "react";
import { useSound } from "../../../../hooks"

type ButtonType = "big" | "small";

interface MainButtonButtonProps {
	text: string;
	disabled?: boolean;
	clickHandler(): void;
	type?: ButtonType;
	smallText?: boolean;
}

const MainButton: FC<MainButtonButtonProps> = (props) => {
	const { text, disabled, clickHandler, type, smallText } = props;
	const {playSound} = useSound();
	const smallButtonWidth: string = smallText ? "140px" : "10vw";

	const handleClick = useCallback(() => {
		if (!disabled) {
			playSound("/sounds/LightClick.mp3");
			const clickTimeout = setTimeout(() => clickHandler());
			return () => clearTimeout(clickTimeout);
		} 
	}, [clickHandler, disabled, playSound]);

	const mainButtonStyles = () => {
		if ((type === "big" || type === "small") && disabled) return "button_disabled";
		if (type === "big" || type === "small") return "main_button";
	}

	return (
		<div className={mainButtonStyles()} style={(type === "small") ? {height: "50px", width: `${smallButtonWidth}`}: {}} onClick={handleClick}>
			<p className={` ${smallText ? "" : "main_button__text" } `}>{text}</p>
		</div>
	);
};

export default MainButton;

